import { Directive, Input } from '@angular/core';
import { Subject } from 'rxjs';
import Company from 'src/app/model/company/company';
import Product from 'src/app/model/product/product';
import { Project } from 'src/app/model/project/project';

@Directive()
export class NonIPBoardSummaryComponent {
  @Input()
  product: Product;
  @Input()
  project: Project;
  @Input()
  client: boolean = false;
  @Input()
  multiple: boolean = false;
  @Input()
  index: number;
  @Input()
  projectContactToCompanySubject: Subject<Map<number, Company>>;
}
